import script from "./Summary.vue?vue&type=script&setup=true&lang=ts"
export * from "./Summary.vue?vue&type=script&setup=true&lang=ts"

import "./Summary.vue?vue&type=style&index=0&id=4a138a04&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a138a04"]])

export default __exports__